<template>
  <div class="users">
    <h1 class="users__title">{{ getMessageByLang('usersText', 'Пользователи') }}</h1>

    <Grid ref="grid" :data-items="gridData" :edit-field="'inEdit'" :sortable="true"
      :sort="sort" :pageable="pageable" :take="take" :skip="skip" :total="total" :loader="loader"
      @datastatechange="dataStateChange" :columns="columns">
      <GridToolbar>
        <Button :theme-color="'primary'" @click="showNewUser">{{ getMessageByLang('addText', 'Добавить') }}</Button>
      </GridToolbar>

      <template v-slot:updated_at="{ props }">
        <td class="k-command-cell k-table-td">
          {{ getFormatedDate(props.dataItem.updated_at, 'DD.MM.YYYY HH:mm') }}
        </td>
      </template>

      <template v-slot:operation="{ props }">
        <td class="k-command-cell k-table-td">
          <div class="cell-control">
            <Button :theme-color="'primary'" class="k-grid-edit-command" :svg-icon="pencilIcon"
                    @click="edit(props.dataItem)" />
            <Button :svg-icon="trashIcon" @click="showModalDelete(props.dataItem)" />
          </div>
        </td>
      </template>
      <GridNoRecords> {{ getMessageByLang('There is no data available custom', 'There is no data available custom') }}</GridNoRecords>
    </Grid>

    <Dialog v-if="itemInEdit" :data-item="itemInEdit" :width="400" @save="updateUser" @cancel="cancel" class="dialog-user" @keydown.esc="cancel">
      <VLoader v-if="isLoadingModal" type="modal" />

      <div v-show="!isLoadingModal">
        <h3 class="custom-modal-title">{{ getMessageByLang('user', 'Пользователь') }} {{ itemInEdit.name }}</h3>

        <Form ref="userForm" @submit="handleSubmit" :initial-values="itemInEdit" :ignoreModified="true">
          <UserForm ref="RefUserForm" :isEdit="itemInEdit.id ? true : false" />
            <div
              class="form-group-grid form-group-tags form-group-select"
            >
            <label class="form-group-grid__label">Теги</label>
            <MultiSelect
              label-key="name"
              value-key="id"  
              textField="name"
              :data-items="tags"
              v-model="editListTag"
            />
          </div>
        </Form>

        <div class="custom-modal-footer">
          <Button @click="cancel">{{ getMessageByLang('cancel', 'Отмена') }}</Button>
          <Button :theme-color="'primary'" @click="updateUser">{{ getMessageByLang('btnSave', 'Сохранить') }}</Button>
        </div>
      </div>
    </Dialog>

    <ModalDelete v-if="isShowModalDelete" @accept="modalDeleteAccept" @cancel="modalDeleteCancel" />
  </div>
</template>

<script>
import { Grid, GridNoRecords, GridToolbar } from '@progress/kendo-vue-grid';
import { MultiSelect } from '@progress/kendo-vue-dropdowns';
import { Form } from "@progress/kendo-vue-form";
import { Button } from '@progress/kendo-vue-buttons';
import { Dialog } from '@progress/kendo-vue-dialogs';
import { cancelIcon, saveIcon } from '@progress/kendo-svg-icons';
import { dataString } from '../../composables/dataString';
import axios from "axios";
import { pencilIcon,trashIcon } from '@progress/kendo-svg-icons';
import { getRespErrorMessage } from '@/utils/errors.js';
import Api from '@/api';
import { getMessageByLang } from '@/utils/translate.js';
import { getFormatedDate } from '@/utils/date';
import { isValidText } from '@/utils/form-validation';
import { addListener,  removeListener } from '@/utils/app';

import UserForm from '@/components/forms/UserForm.vue';
import VLoader from '@/ui-kit/components/VLoader.vue';
import ModalDelete from '@/components/modals/ModalDelete.vue';

export default {
  components: {
    Grid,
    GridNoRecords,
    Button,
    Dialog,
    Form,
    UserForm,
    VLoader,
    GridToolbar,
    MultiSelect,
    ModalDelete
  },
  data: function () {
    return {
      getMessageByLang: getMessageByLang,
      getFormatedDate: getFormatedDate,
      isLoadingModal: false,
      cancelIcon, saveIcon,
      filter: null,
      sort: null,
      pageable: true,
      gridData: [],
      skip: 0,
      take: 10,
      total: 0,
      updatedData: [],
      editID: null,
      loader: false,
      itemInEdit: false,
      pencilIcon,
      trashIcon,
      isValidText: isValidText,
      RefUserForm: null,
      tags: [],
      editListTag: [],
      isShowModalDelete: false,
      deleteItem: null
    };
  },
  computed: {
    columns() {
      return [
        { field: 'id', width: 60, title: 'ID' },
        { field: 'name', title: getMessageByLang('nameTxt', 'Имя')},
        { field: 'email', title: 'Email' },
        { field: 'email_verified_at', title: getMessageByLang('dateUpdate', 'Дата верификации'), type: "date", format: '{0:dd.MM.yyyy}', },
        { field: 'created_at', title: getMessageByLang('dateCreate', 'Дата создания'), type: "date", format: '{0:dd.MM.yyyy}', },
        { cell: 'operation', filterable: false, width: '150px' },
      ]
    },
    dataState() {
      return {
        sort: this.sort,
        skip: this.skip,
        take: this.take,
      };
    },
  },
  created: function () {
    this.getData();
    this.getTags();
  },
  methods: {
    showModalDelete(item) {
      this.deleteItem = item;
      this.isShowModalDelete = true;
    },

    modalDeleteAccept() {
      this.removeUser(this.deleteItem);
    },

    modalDeleteCancel() {
      this.isShowModalDelete = false;
    },

    async getTags() {
      const response = await Api.tags.get();
      this.tags = response?.data?.data || [];
    },
    
    removeUser(user) {
      axios.delete(`/api/v1/users/${user.id}`)
          .then(() => {
            this.isShowModalDelete = false;
            this.getData();
          })
          .catch((error) => {
            console.error(error);
          })
    },

    showNewUser() {
      this.itemInEdit = {
        role_id: 1
      };
      this.editListTag = [];
    },

    edit(dataItem) {
      this.itemInEdit = this.cloneProduct(dataItem);
      this.editListTag = this.itemInEdit?.tags || [];
    },
    remove(dataItem) {
      this.gridData = this.gridData.filter(p => p.id !== dataItem.id);
    },
    cloneProduct(item) {
      return Object.assign({}, item);
    },
    cancel() {
      this.itemInEdit = undefined;
    },
    async getData() {
      try {
        this.loader = true;
        const url = '/api/v1/users?' + dataString(this.dataState);
        const res = await axios.get(url);

        if (res?.data?.message) {
          this.total = res.data.total;
          this.updatedData = [...res.data.data];
          this.gridData = res.data.data;
        }

      } catch (err) {
        console.error(err);
        this.total = 0;
        this.updatedData = [];
        this.gridData = [];

      } finally {
        this.loader = false;
      }
    },

    isValidUser(dataItem = {}) {
      const requiredTextOptions = ['email', 'name', 'password', 'password_confirmation', 'role_id'];
      const invalidOptions = [];

      for(const item of requiredTextOptions) {
        if(!this.isValidText(dataItem[item])) {
          invalidOptions.push(item);
        }
      }

      if(invalidOptions.length > 0) {
        this.$refs.RefUserForm.showInvalidOptions(invalidOptions);
      }

      return !invalidOptions.length > 0;
    },

    updateUser: function () {
      this.$refs.userForm.onSubmit();
    },

    async saveTags(userId) {
      const list = this.editListTag.map((tag) => tag.id);
      await Api.tags.addTagsToUser(userId, list);
    },

    async removeTags(userId) {
        const listForRemove = this.itemInEdit.tags.filter((tag) => {
        let isHas = false;

         for(const selectedTag of this.editListTag) {
          if(selectedTag.id === tag.id) {
            isHas = true;
          }
         }

         if(!isHas) return tag.id;
      })

      await Api.tags.removeTagsFromUser(userId, listForRemove);
    },

    async handleSubmit(dataItem) {
      try {
        this.isLoadingModal = true;
        const formValues = JSON.stringify(dataItem, null, 2);        

        if (dataItem.id) {
          var self = this;
          this.saveTags(dataItem.id);
          this.removeTags(dataItem.id);

          axios.put('/api/v1/users/' + dataItem.id, formValues)
            .then(function () {})
            .catch(function (error) {
              if (error.response) {
                if (error.response.data.errors) {
                  self.$refs.userForm.form.errors.VALIDATION_SUMMARY = error.response.data.message;
                  for (let key in error.response.data.errors) {
                    self.$refs.userForm.form.errors[key] = error.response.data.errors[key][0];
                  }
                } else {
                  if (error.response.data.message) {
                    self.$refs.userForm.form.errors.VALIDATION_SUMMARY = error.response.data.message;
                  }
                }
              } else if (error.request) {
                console.log(error.request);
              }
            });

        } else {
          const response = await Api.users.create(formValues);
          this.saveTags(response?.data?.data?.id);
        }

        // не успевает обновится бд. Поэтому таймаут
        setTimeout(() => {
          this.isLoadingModal = false;
          this.itemInEdit = false;
          this.getData();
        }, 600)

      } catch (err) {
        console.error(err);
        this.isLoadingModal = false;
        const messageText = getRespErrorMessage(err);
        alert(messageText);
      }
    },
    createAppState: function (dataState) {
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.filter = dataState.filter;
      this.sort = dataState.sort;
      this.getData();
    },
    dataStateChange: function (event) {
      this.createAppState(event.data);
    },

    addEscListener(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.isShowModalDelete = false;
        this.itemInEdit = undefined;
      }
    },
  },

  mounted() {
    addListener(this.addEscListener)
  },

  unmounted() {
    removeListener(this.addEscListener)
  }
};
</script>

<style lang="scss">
.users {
  &__title {
    margin-bottom: 1rem;
  }

  &__header {
    margin: 1rem 0;
  }
}

.dialog-user {
  & .k-dialog {
    min-height: 340px !important;
  }
}

.form-group-tags {
  margin-top: 1rem;
}
</style>